var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { color } from '../../../constants/color';
export function getAxesConfig(axesProps, leftScale, bottomScale, height, margins) {
    var shared = {
        height: height,
        margins: margins,
        isCanvasChild: true,
        stroke: color.theme.typography.ink,
        tickStroke: color.theme.typography.ink,
        numTicks: 5,
        hideTicks: true
    };
    var left = __assign(__assign(__assign({}, shared), { orientation: 'left', scale: leftScale, tickLength: 5, tickLabelProps: function () { return ({
            transform: 'translate(-2, 0)',
            textAnchor: 'end'
        }); } }), axesProps.left);
    var bottom = __assign(__assign(__assign({}, shared), { orientation: 'bottom', top: height, scale: bottomScale, tickLength: 5, tickLabelProps: function () { return ({
            textAnchor: 'middle'
        }); } }), axesProps.bottom);
    return {
        left: left,
        bottom: bottom
    };
}
//# sourceMappingURL=getAxesConfig.js.map